<template>
  <div>
    <b-checkbox v-if="disk_list && disk_list.length > 0" v-model="hide_docker_overlay">
      <span v-b-tooltip.hover.right title="도커의 컨테이너 볼륨(lib, container 등) 표시 여부를 설정합니다">
        도커 볼륨 숨기기
        <span class="text-info">
          <i style="cursor:pointer" class="fas fa-question-circle"></i>
        </span>
      </span>
    </b-checkbox>

    <b-checkbox v-if="disk_list && disk_list.length > 0" :disabled="os_type != 'linux'" v-model="show_permission">
      <span v-b-tooltip.hover.right title="폴더의 권한 정보를 표시합니다 실험적 기능은 언제드 사라질 수 있는 베타 기능입니다">
        권한 표시 (실험적 기능)
        <span class="text-info">
          <i style="cursor:pointer" class="fas fa-question-circle"></i>
        </span>
      </span>
    </b-checkbox>

    <hr v-if="disk_list && disk_list.length > 0">
    <b-row v-if="hide_docker_overlay == false || (hide_docker_overlay && (d.mountpoint.indexOf('docker/overlay') < 0 && d.mountpoint.indexOf('docker/containers') < 0 && d.mountpoint.indexOf('docker/volumes') < 0))" v-for="(d, index) in disk_list" v-bind:key="index" class="animated fadeIn fadeOut">
      <b-col sm="2">
        {{d.used}} / {{d.total}}
      </b-col>
      <b-col sm="1">
        {{d.percent}}
      </b-col>
      <b-col>
        <b-progress :max="100" height="1.1rem">
          <b-progress-bar :value="Number(d.percent.replace('%', ''))">
            <span class="ml-5 mr-5 text-dark">{{d.mountpoint}}</span>
          </b-progress-bar>
        </b-progress>
      </b-col>
    </b-row>
    <hr v-if="disk_list && disk_list.length > 0">
    <b-button class="btn-add" v-if="show && only_view != true" block href="#" variant="success" @click="$parent.$emit('save')">저장</b-button>
    <!-- @dragstart="dragstart($event, item)" -->
    <!-- @drag="ondrag($event, item)" -->
    <b-card-group v-if="show && item.length"
      style="height:fit-content"
      @dragend="dragend($event, item)"
      @drop="drop($event, item)"
      @dragover="dragover($event, item)"
      @dragenter="dragenter($event, item)"
      @dragleave="dragleave($event, item)"
    >
      <!-- 대상 설정 -->
      <b-card style="border-radius: 5px;">
        <i class="float-right fa fa-refresh" @click="refresh" style="cursor: pointer;"></i>
        <folder
          @dragstart_custom="($event, item) => dragstart($event, item)"
          @add_white_list="x => $parent.$emit('add_white_list', x)"
          @add_white_list_file="x => $parent.$emit('add_white_list_file', x)"
          @add_scan_list="x => $parent.$emit('add_scan_list', x)"
          v-for="child in item" :item="child" :key="child.id" @path="get_path"

          :show_permission="show_permission"
          :os_type="os_type"
          :msg_uid="'UID 가 root 일 경우 빨간색으로 강조됩니다'"
          :msg_gid="'GID 가 root 일 경우 빨간색으로 강조됩니다'"
          :msg_sticky="'Sticky 비트가 설정되어 있습니다'"
        />
      </b-card>
      <!-- 설정된 대상 -->
      <b-card class="w-50" style="height:fit-content; border-radius: 5px;">
        <div class="dropzone_path_scan_list" style="border-radius: 5px; min-height: 35%; z-index:-100; width:100%; padding : 5px;">
          <p class="w-100 text-center font-weight-bold">
            <span v-b-tooltip.hover title="모니터링 대상 폴더를 지정합니다 웹쉘 탐지 솔루션의 경우 업로드 폴더 또는 웹 폴더로 설정을 권장합니다 위변조 설정의 경우 위변조 모니터링의 경우 설정 및 백업 폴더를 권장합니다">
              * 모니터링 폴더
              <span class="text-info">
                <i style="cursor:pointer" class="fas fa-question-circle"></i>
              </span>
            </span>

            (<b-button size="sm" variant="link" @click="modal_scan_list_history = true">이전 기록</b-button>)
            <b-button size="sm" class="float-right" :disabled="scan_list.length == 0" variant="warning" @click="$parent.$emit('clear', 'scan_list')">초기화</b-button>
          </p>
          <hr>
          <div style="width: fit-content;" v-for="(s, index) in scan_list" :value="s" :key="'scan_list_'+index" :item="s">
            <b-button size="sm" variant="danger" @click="$parent.$emit('remove', 'scan_list', s)">X</b-button> {{s}} <br />
          </div>
        </div>
        <br>
        <!-- 예외 폴더 -->
        <div class="dropzone_path_white_list" style="border-radius: 5px; min-height: 35%; z-index:-100; width:100%; padding : 5px;">
          <p class="w-100 text-center font-weight-bold">
            <span v-b-tooltip.hover title="예외 처리할 부분을 지정합니다 해당 부분은 탐지되지 않습니다">
              예외 폴더 <span v-if="white_file_active != true"> 또는 파일 </span>
              <span class="text-info">
                <i style="cursor:pointer" class="fas fa-question-circle"></i>
              </span>
            </span>
            <b-button size="sm" class="float-right" :disabled="!white_path || white_path.length == 0" variant="warning" @click="$parent.$emit('clear', 'white_path')">초기화</b-button>
          </p>
          <hr>
          <div style="width: fit-content;" v-for="(s, index) in white_path" :value="s" :key="'white_path_'+index" :item="s">
            <b-button size="sm" variant="danger" @click="$parent.$emit('remove', 'white_path', s)">X</b-button> {{s}} <br />
          </div>
          <hr>
          <b-input-group>
            <b-form-input class="white_path_one" type="text" @keyup.enter="add_white_list_custom" v-model="input_custom_1" :placeholder="`Ex) ${scan_list.length > 0 ? scan_list[0]+( scan_list[0].indexOf('/') > -1 ? '/' : '\\' )+'white_file_target' : '/var/www/html/upload/backup'}`"></b-form-input>
            <b-button class="btn-addition" variant="primary" @click="add_white_list_custom">추가</b-button>
          </b-input-group>
        </div>
        <br>
        <div v-if="white_file_active == true" class="dropzone_path_white_list_file" style="border-radius: 5px; min-height: 35%; z-index:-100; width:100%; padding : 5px;">
          <p class="w-100 text-center font-weight-bold">
            <span v-b-tooltip.hover title="예외 처리할 파일을 지정합니다 해당 파일은 탐지되지 않습니다">
              예외 파일
              <span class="text-info">
                <i style="cursor:pointer" class="fas fa-question-circle"></i>
              </span>
            </span>
            <b-button size="sm" class="float-right" :disabled="!white_file || white_file.length == 0" variant="warning" @click="$parent.$emit('clear', 'white_file')">초기화</b-button>
          </p>
          <hr>
          <div style="width: fit-content;" v-for="(s, index) in white_file" :value="s" :key="'white_file_'+index" :item="s">
            <b-button size="sm" variant="danger" @click="$parent.$emit('remove', 'white_file', s)">X</b-button> {{s}} <br />
          </div>
          <!-- 예외 폴더는 파일도 입력이 가능해야 함 -->
          <!-- 여기서는 기존 사용하는 경로인지 확인 필요 -->
        </div>
        <hr v-if="white_file_active == true">
        <b-input-group v-if="white_file_active == true">
          <b-form-input class="white_path_file" type="text" @keyup.enter="add_white_file_custom" v-model="input_custom_2" :placeholder="`Ex) ${scan_list.length > 0 ? scan_list[0]+( scan_list[0].indexOf('/') > -1 ? '/' : '\\' )+'white_file_target' : '/var/www/html/upload/backup'}`"></b-form-input>
          <b-button class="btn-addition" variant="primary" @click="add_white_file_custom">추가</b-button>
        </b-input-group>
      </b-card>

    </b-card-group>
    <b-button class="font-weight-bold fadeIn fadeOut pulse" v-if="item.length == 0 && is_refresh" block @click="refresh" style="height:80px;">새로고침</b-button>
    <b-card v-if="item.length == 0 && is_refresh != true" class="text-center">
      <span> 에이전트로부터 폴더 리스트 업로드가 실패했습니다, 에이전트가 온라인 상태인지 확인해 주시기 바랍니다 </span>
    </b-card>
    <b-modal title="모니터링 폴더 이전 기록"  class="modal-info" v-model="modal_scan_list_history" @ok="modal_scan_list_history = false" ok-only header-bg-variant="info" ok-variant="info">
      <p v-if="!scan_list_history || !scan_list_history.length">이전 데이터가 없습니다</p>
      <table v-else>
        <thead class="text-center font-weight-bold">
          <tr>
            <td>
              변경 시각
            </td>
            <td>
              변경 이전 폴더 목록
            </td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(x, index) in scan_list_history" v-bind:key="index" style="border-top: 1px solid gray;">
            <td class="text-center" style="width: 40%">
              {{x.updated_at | sdate}}
            </td>
            <td>
              <p class="m-1" v-for="(y, index) in x.target_sub">{{y}}</p>
              <!-- TODO : 향후 이전 기록 바로 적용 추가 될 수 있음 -->
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>
<style>
  .pulse {
  cursor: pointer;
  box-shadow: 0 0 0 rgba(204,169,44, 0.4);
  animation: pulse 2s infinite;
}
.pulse:hover {
  animation: none;
}

@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(204,169,44, 0.4);
  }
  70% {
      -webkit-box-shadow: 0 0 0 10px rgba(204,169,44, 0);
  }
  100% {
      -webkit-box-shadow: 0 0 0 0 rgba(204,169,44, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(204,169,44, 0.4);
    box-shadow: 0 0 0 0 rgba(204,169,44, 0.4);
  }
  70% {
      -moz-box-shadow: 0 0 0 10px rgba(204,169,44, 0);
      box-shadow: 0 0 0 10px rgba(204,169,44, 0);
  }
  100% {
      -moz-box-shadow: 0 0 0 0 rgba(204,169,44, 0);
      box-shadow: 0 0 0 0 rgba(204,169,44, 0);
  }
}
</style>
<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
